module.exports = __webpack_public_path__ + "static/img/facebook.619edae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.png
// module id = XQRD
// module chunks = 0